export const SPRING_CONFIG = {
  NO_BOUNCE: {
    stiffness: 100,
    damping: 13,
    mass: 0.4,
  },
};
